import React from "react";
import Svg, {
  Path,
  Defs,
  LinearGradient,
  Stop,
  Rect,
  G,
  ClipPath,
} from "react-native-svg";
import { TouchableOpacity } from "react-native";
import appStyles from "../../appStyles";

export default function ReviewReportsIcon(props) {
  const width = props.width || 30;
  const height = props.height || 30;
  const fillColor = props.fillColor || "#FFF";

  return (
    <TouchableOpacity style={[appStyles.iconContainer, props.style]} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath="url(#clip0_teams)">
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.4561 5.625C11.5059 5.625 9.92489 7.20599 9.92489 9.15625C9.92489 11.1065 11.5059 12.6875 13.4561 12.6875C14.8848 12.6875 16.1152 11.8391 16.6713 10.6187C16.697 10.544 16.7271 10.4717 16.7613 10.4021C16.9074 10.0147 16.9874 9.59481 16.9874 9.15625C16.9874 7.20599 15.4064 5.625 13.4561 5.625ZM13.4561 16.4375C15.9146 16.4375 18.0884 15.2191 19.4068 13.3532L27.8217 15.146C28.8345 15.3618 29.8305 14.7157 30.0463 13.7029C30.2621 12.6901 29.6159 11.6941 28.6031 11.4784L20.7096 9.79664C20.728 9.58562 20.7374 9.37203 20.7374 9.15625C20.7374 5.13493 17.4775 1.875 13.4561 1.875C9.43482 1.875 6.17489 5.13493 6.17489 9.15625C6.17489 13.1776 9.43482 16.4375 13.4561 16.4375ZM6.89029 18.1064C6.32202 18.098 5.78059 18.3478 5.41818 18.7856L0.430685 24.8106C-0.0325306 25.3702 -0.130847 26.1469 0.178346 26.8043C0.487539 27.4616 1.1486 27.8812 1.87502 27.8812H16.425C17.0153 27.8812 17.5711 27.6032 17.9252 27.1309L22.2877 21.3122C22.7107 20.748 22.7814 19.9942 22.4707 19.3612C22.1599 18.7282 21.5204 18.3231 20.8153 18.3127L6.89029 18.1064ZM5.86122 24.1312L7.73362 21.8693L17.0794 22.0077L15.4873 24.1312H5.86122Z"
            fill="url(#paint0_linear_teams)"
          />
        </G>
        <Defs>
          <LinearGradient
            id="paint0_linear_teams"
            x1="-8.38608e-07"
            y1="7.51491"
            x2="11.3764"
            y2="34.4089"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor={fillColor} />
            <Stop offset="1" stopColor={fillColor} />
          </LinearGradient>
          <ClipPath id="clip0_teams">
            <Rect width="30" height="30" fill="white" />
          </ClipPath>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
